import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { DocumentDetailsMetaService } from '../service/document-details-meta.service';
import * as DocumentDetailsMetaActions from './document-details-meta.actions';
import { catchError, map, of, switchMap } from 'rxjs';

@Injectable()
export class DocumentDetailsMetaEffects {
  private actions$ = inject(Actions);
  private documentDetailsMetaService = inject(DocumentDetailsMetaService);

  loadDocumentDetails$ = createEffect(() =>
    this.actions$.pipe(
      ofType(DocumentDetailsMetaActions.initDocumentDetailsMeta),
      switchMap(({ categoryId, documentId, language }) => {
        return this.documentDetailsMetaService.getDocumentDetailsMeta(categoryId, documentId, language).pipe(
          map((documentDetailsMeta) => {
            return DocumentDetailsMetaActions.loadDocumentDetailsMetaSuccess({ documentDetailsMeta });
          }),
          catchError((error) => {
            console.error('API Document Details Meta Error:', error);
            return of(DocumentDetailsMetaActions.loadDocumentDetailsMetaFailure({ error: error.message }));
          })
        );
      })
    )
  );
}
